import React, { useContext } from "react"
import { useNavigate } from "react-router"

import basket from "../../assets/Header_Icons/Cart.svg"
import { GlobalContext } from "../../context/GlobalContext"

const Basket = () => {
    const navigate = useNavigate()
    const { basketCount, setBasketCount } = useContext(GlobalContext)

    const openOrderTab = () =>{
        navigate("/order")
        setBasketCount(0)
    }
    
    return (
        <>
            <div className="flex">
                <button type="button" className="flex h-full" onClick={ openOrderTab }>
                    <>
                        <img src={ basket } height={ "32px" } width={ "32px" } alt={ "basket" }/>
                        { (basketCount > 0) && <div className="flex w-[18px] h-[18px] 
                          flex-col justify-center items-center shrink-0 gap-2.5 
                          border rounded-full background bg-tertiary-500 relative 
                          right-[11px] bottom-[7px] solid border-white">
                            <span className="text-white text-xs font-bolder text-right pt-[2px]">
                                { basketCount || 0 }
                            </span>
                        </div> }
                    </>
                </button>
            </div>
        </>
    )
}

export default Basket
